module.exports = __webpack_public_path__ + "static/media/thumbnail.93754a81.jpg";